
import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import { useNavigate } from "react-router";

import { Grid, Button, IconButton, Switch, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Typography, Dialog, DialogActions, DialogContent, FormControl, TextField, FormLabel, InputAdornment, OutlinedInput, CircularProgress, InputLabel, MenuItem, Select, ButtonGroup, InputBase, Paper, Chip } from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import UndoIcon from '@mui/icons-material/Undo';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import SearchIcon from "@mui/icons-material/Search";

import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { Layout } from "../../components/Layout"

import { TablePaginationActions } from "../../helpers/TablePaginationActions";

import { usePages } from "../../hooks/usePages";

import { TableTheadStyle, TablePaddingStyle } from "../../styles/TableStyle";

import { ObtenerTipoUsuarios } from "../../connections/catalogos/TipoUsuarioConnection";
import { ObtenerUnidades } from "../../connections/catalogos/UnidadConnection";
import { ActualizarUsuario, AgregarUsuario, BuscarUsuarioRH, Usuarios } from "../../connections/admin/UsuarioConnection";

import { UsuarioProps } from "../../interfaces/admin/UsuarioInterface";
import { TipoUsuarioProps } from "../../interfaces/catalogos/TipoUsuarioInterface";
import { UnidadProps } from "../../interfaces/catalogos/UnidadInterface";

type ActionType = 'Nuevo' | 'Buscar';

export const UsuariosPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [openModal, setOpenModal] = useState( false );
    const [showPassword, setShowPassword] = useState(false);

    const [loading, setLoading] = useState( false );
    const [loadingData, setLoadingData] = useState( true );
    const [loadingBuscar, setLoadingBuscar] = useState( false );

    const [idUsuario, setIdUsuario] = useState( 0 );
    const [usuarios, setUsuarios] = useState<UsuarioProps[]>( [] );

    const [curp, setCurp] = useState( '' );
    const [nombre, setNombre] = useState( '' );
    const [apellido1, setApellido1] = useState( '' );
    const [apellido2, setApellido2] = useState( '' );
    const [correoElectronico, setCorreoElectronico] = useState( '' );
    const [contrasena, setContrasena] = useState( '' );

    const [tipousuario, setTipousuario] = useState( 0 );
    const [tipousuarioArray, setTipousuarioArray] = useState<TipoUsuarioProps[]>( [] );

    const [unidad, setUnidad] = useState( 0 );
    const [unidadArray, setUnidadArray] = useState<UnidadProps[]>( [] );

    const [curpBuscar, setCurpBuscar] = useState( '' );
    const [action, setAction] = useState<ActionType>( 'Buscar' );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } = usePages( 5 );

    const handleChangeChecked = async ( checked: boolean, id: number ) => {

        const usuarioSelected = usuarios.find( ( elem ) => elem.idUsuario === id );

        if( usuarioSelected ){

            const usuarioUpdate: UsuarioProps = {
                idUsuario: id,
                curp: usuarioSelected.curp,               
                nombre: usuarioSelected.nombre,               
                apellido1: usuarioSelected.apellido1, 
                apellido2: usuarioSelected.apellido2, 
                correoElectronico: usuarioSelected.correoElectronico, 
                contrasena: usuarioSelected.contrasena, 
                activo: checked ,
                idEstatus: checked ? 1 : 2,
                idTipoUsuario: usuarioSelected.idTipoUsuario,
                idUnidad: usuarioSelected.idUnidad,
            };    

            await ActualizarUsuario( usuarioUpdate ).then( resp => {
                
                if( resp.idUsuario ){

                    var newArray = usuarios.map( ( elem ) => {

                    if( elem.idUsuario === id ){
                        elem.activo = checked;
                    }
            
                        return elem;
                    });
            
                    setUsuarios( newArray );
                
                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));   

                }    
    
            });
        }       

    }

    const handleGuardar = async () => {

        if( idUsuario !== 0 ){

            const usuarioSelected = usuarios.find( ( elem ) => elem.idUsuario === idUsuario );

            if( usuarioSelected ){

                setLoading( true );

                const usuarioUpdate: UsuarioProps = {
                    idUsuario: idUsuario,
                    curp,
                    nombre,               
                    apellido1,
                    apellido2,
                    correoElectronico,
                    contrasena,
                    activo: usuarioSelected.activo,
                    idEstatus: usuarioSelected.activo ? 1 : 2 ,
                    idTipoUsuario: tipousuario,
                    idUnidad: unidad,
                };    
    
                await ActualizarUsuario( usuarioUpdate ).then( resp => {

                    const { success, message, idUsuario } = resp;
                    
                    if( success ){

                        if( idUsuario ){
    
                            setTimeout(() => {
                                
                                var newArray = usuarios.map( ( elem ) => {
            
                                    if( elem.idUsuario === idUsuario ){
                                        elem.curp = curp;
                                        elem.nombre = nombre;
                                        elem.apellido1 = apellido1;
                                        elem.apellido2 = apellido2;
                                        elem.correoElectronico = correoElectronico;
                                        elem.contrasena = contrasena;
                                        elem.idEstatus = usuarioSelected.activo ? 1 : 2;
                                        elem.activo = usuarioSelected.activo;
                                        elem.idTipoUsuario = tipousuario;
                                        elem.tipoUsuario = resp.tipoUsuario ?? '';
                                        elem.idUnidad = unidad;
                                        elem.unidad = resp.unidad ?? '';
                                    }
                            
                                    return elem;
                                });
                        
                                setUsuarios( newArray );
                                setOpenModal( false );
                                setShowPassword( false );
                                setLoading( false );

                                dispatch( openSnackbar({ message: message, variant: 'success' }));   
                                
                            }, 700);
        
                        }    

                    }
                    else {
                        
                        dispatch( openSnackbar({ message: message, variant: 'success' }));   
                        setLoading( false );

                    }    
        
                });
            }       
    

        }
        else {

            const usuarioAdd: UsuarioProps = {
                idUsuario: 0,
                curp,
                nombre,               
                apellido1,
                apellido2,
                correoElectronico,
                contrasena,
                activo: true,
                idEstatus: 1,
                idTipoUsuario: tipousuario,
                idUnidad: unidad,
            };

            setLoading( true );

            await AgregarUsuario( usuarioAdd ).then( resp => {

                const { success, message, idUsuario } = resp;

                if( success ){
               
                    if( idUsuario ){                
                
                        setTimeout(() => {
                            
                            setUsuarios([ ...usuarios, resp ]);
                            setOpenModal( false );
                            setShowPassword( false );
                            setLoading( false );
                            
                            dispatch( openSnackbar({ message: message, variant: 'success' }));   
    
                        }, 700);
    
                    }    

                }
                else {
                    
                    dispatch( openSnackbar({ message: message, variant: 'success' }));   
                    setLoading( false );

                }   
    
            });

        }

    }

    const handleClose = () => {

        setIdUsuario( 0 );
        setAction( 'Buscar' );
        setCurpBuscar( '' );
        setCurp( '' );
        setNombre( '' );
        setApellido1( '' );
        setApellido2( '' )
        setCorreoElectronico( '' )
        setContrasena( '' );
        setTipousuario( 0 );
        setUnidad( 0 );
        
        setShowPassword( false );

    }

    const handleBuscarUsuario = async () => {

        if( curpBuscar === '' ){
            return false;
        }        

        setLoadingBuscar( true );

        await BuscarUsuarioRH( curpBuscar ).then( resp => {

            if( resp ){               

                const { success, nombres, apellido_Primero, apellido_Segundo, email, curp } = resp;

                if( success ){                        
                    
                    setTimeout(() => {

                        setCurp( curp ?? '' );
                        setNombre( nombres ?? '' );
                        setApellido1( apellido_Primero ?? '' );
                        setApellido2( apellido_Segundo ?? '' );
                        setCorreoElectronico( email ?? '' );
                
                        setCurpBuscar('');

                        setLoadingBuscar( false );

                    }, 100);
                }
                else {                        

                    setCurp( '' );
                    setNombre( '' );
                    setApellido1( '' );
                    setApellido2( '' );
                    setCorreoElectronico( '' );
                    
                    setLoadingBuscar( false );

                    dispatch( openSnackbar({ message: `No se encontro la persona con el CURP: ${ curpBuscar }`, variant: 'success' }));   
                }

            }            

        });
        
    }

    useEffect(() => {
      
        async function obtener(){

            setLoadingData( true );
            setUsuarios( [] );

            await Usuarios().then( resp => {

                setTimeout(() => {
                    
                    setUsuarios( resp );
                    setLoadingData( false );

                }, 700);

            });

        }

        obtener();

    }, [ ])   

    useEffect(() => {
      
        async function obtener(){

            await ObtenerTipoUsuarios().then( resp => {

                setTimeout(() => {
                    
                    setTipousuarioArray( resp );

                }, 700);

            });

        }

        obtener();

    }, [ ])   

    useEffect(() => {
      
        async function obtener(){

            await ObtenerUnidades().then( resp => {

                setTimeout(() => {
                    
                    setUnidadArray( resp );

                }, 700);

            });

        }

        obtener();

    }, [ ])   

    return (
        
        <Layout breadcrumbs={[ { text: 'Administración' }, { text: 'Usuarios' } ]} backgroundPaper={false}>

            <Grid container spacing={3} >  
                
                <Grid size={{ xs: 6 }} textAlign={'start'}>

                    <Button color="secondary" startIcon={ <UndoIcon /> } variant="text" sx={{ mt: 1 }} onClick={ () => navigate( '/' ) }> 
                        Regresar
                    </Button> 

                </Grid>

                <Grid size={{ xs: 6 }} textAlign={'end'}>

                    <Button                      
                        variant="contained" 
                        sx={{ mt: 1 }} 
                        onClick={ () => {
                            handleClose();
                            setOpenModal( true );
                        }}
                    > 
                        Agregar
                    </Button> 

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>   

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'5%' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'20%' }}> Nombre completo </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'20%' }}> Correo electrónico </TableCell>   
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%' }}> Tipo de usuario </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'25%' }}> Unidad </TableCell>  
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%' }}> </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                ? 
                                    usuarios.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                : 
                                    usuarios
                            )
                            .map( ( { idUsuario, nombre, apellido1, apellido2, correoElectronico, contrasena, activo, idTipoUsuario, tipoUsuario, idUnidad, unidad, curp } ) => (

                                <TableRow key={ idUsuario } >
                                
                                    <TableCell sx={{ fontWeight: 'bold' }}>

                                        <Chip                                         
                                            label={ idUsuario }
                                            color={ activo ? 'primary' : 'error' }
                                        />
                                        
                                    </TableCell>

                                    <TableCell>
                                        <Typography fontSize={14} fontWeight={'bold'}>{ nombre.toUpperCase() } { apellido1.toUpperCase() } { apellido2?.toUpperCase() }</Typography>
                                        <Typography fontSize={12} mt={1}>{ curp }</Typography>                              
                                    </TableCell>    

                                    <TableCell>
                                        { correoElectronico }
                                    </TableCell>      

                                    <TableCell>
                                        { tipoUsuario }
                                    </TableCell>          

                                    <TableCell>
                                        { unidad }
                                    </TableCell>                                         
                                                  
                                    <TableCell sx={{ textAlign: 'end' }}>
                                        
                                        <Switch 
                                            checked={ activo } 
                                            onChange={ ( e ) => handleChangeChecked( e.target.checked, idUsuario ) }
                                        />                                            
                          
                                        <IconButton 
                                                color="primary" 
                                                aria-label="edit" 
                                                component="span" 
                                                onClick={ () => {

                                                    setIdUsuario( idUsuario );
                                                    setCurp( curp );
                                                    setNombre( nombre );
                                                    setApellido1( apellido1 );
                                                    setApellido2( apellido2 )
                                                    setCorreoElectronico( correoElectronico )
                                                    setContrasena( contrasena );
                                                    setTipousuario( idTipoUsuario );
                                                    setUnidad( idUnidad );

                                                    setOpenModal( true );
                                                }}
                                            >                                                        
                                            <EditIcon />
                                        </IconButton>  

                                    </TableCell>

                                </TableRow>

                            ))
                        }                    

                        { 
                            ( usuarios.length === 0 && !loadingData )
                            ?   
                                <TableRow style={{ height: 53 }}>

                                    <TableCell colSpan={7} align="center"> 

                                        <Typography variant="caption" fontWeight={'bold'}> No se encontraron resultados </Typography>
                                        
                                    </TableCell>

                                </TableRow>                     
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={7} align="center"> 

                                            <CircularProgress size={32} />
                                            
                                        </TableCell>

                                    </TableRow>                     
                        }
                        
                    </TableBody>

                    <TableFooter>

                        {
                            usuarios.length !== 0
                            &&

                                <TableRow>

                                    <TableCell colSpan={2} sx={{ border: 'none'}}>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}> 
                                            Total de registros: { usuarios.length } 
                                        </Typography>
                                    </TableCell> 

                                    <TablePagination  
                                        sx={{ border: 'none'}}
                                        rowsPerPageOptions={[ 5, 10, 20, 50, 100 ]}
                                        colSpan={8}
                                        count={ usuarios.length }                                        
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }          

                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }

                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage="Filas por página"                                            
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                            }
                                        }  
                                    />

                                </TableRow>

                            }

                    </TableFooter>
                    
                </Table>

            </TableContainer>

            <Dialog open={ openModal } maxWidth='sm' fullWidth={true}>       
            
                <DialogContent>      

                    <Grid container spacing={1}>

                         {
                            idUsuario === 0
                            &&
                                <Grid size={12} textAlign={'center'}>

                                    <ButtonGroup
                                        fullWidth
                                        disableElevation
                                        variant="text"
                                        aria-label="Disabled button group"
                                    >
                                        <Button variant={ action === 'Buscar' ? "contained" : "text" } onClick={ () => setAction( 'Buscar' ) }>
                                            Buscar usuario en RRHH
                                        </Button>
                                        <Button variant={ action === 'Nuevo' ? "contained" : "text" } onClick={ () => setAction( 'Nuevo' ) }>
                                            Nuevo usuario
                                        </Button>
                                    </ButtonGroup>

                                </Grid>
                        }

                        {
                            ( action === 'Buscar' && idUsuario === 0 )
                            &&     
                                <Grid size={12} mt={1}> 

                                    <Paper
                                        component="form"
                                        sx={{ p: '2px 4px', display: 'flex', alignItems: 'center' }}
                                    >
                                    
                                        <InputBase
                                            sx={{ ml: 1, flex: 1, py: 1 }}
                                            placeholder="Buscar usuario"
                                            inputProps={{ 'aria-label': 'Buscar usuario' }}
                                            value={ curpBuscar }
                                            onChange={ ( e ) => setCurpBuscar( e.target.value.toUpperCase() ) }
                                        />

                                        <Button 
                                            type="button" 
                                            variant='contained'                                  
                                            size='small'
                                            sx={{ borderRadius: 10, mr: 1 }} 
                                            disabled={ curpBuscar.length < 18 }
                                            loading={ loadingBuscar }
                                            onClick={ handleBuscarUsuario }
                                        >
                                            <SearchIcon />
                                        </Button>      

                                    </Paper>   

                                </Grid>   
                        }

                        <Grid size={{ xs: 12, md: 6 }}>

                            <FormControl sx={{ mt: 2 }} required fullWidth>

                                <FormLabel sx={{ fontWeight: '700', fontSize: 14, color: 'rgba(0, 0, 0, 0.8)', mb: 1}}>CURP</FormLabel>
                                <TextField
                                    placeholder="XXXX000000XXXXXX00"
                                    autoComplete="off"                             
                                    variant="outlined"       
                                    value={ curp }           
                                    onChange={ (e) => setCurp( e.target.value ) }         
                                    disabled={ action === 'Buscar' && idUsuario === 0 }
                                />

                            </FormControl>

                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>

                            <FormControl sx={{ mt: 2 }} required fullWidth>

                                <FormLabel sx={{ fontWeight: '700', fontSize: 14, color: 'rgba(0, 0, 0, 0.8)', mb: 1}}>Nombre(s)</FormLabel>
                                <TextField
                                    placeholder="Juan"
                                    autoComplete="off"                             
                                    variant="outlined"     
                                    value={ nombre }           
                                    onChange={ (e) => setNombre( e.target.value ) }
                                    disabled={ action === 'Buscar' && idUsuario === 0 }
                                />

                            </FormControl>

                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>

                            <FormControl sx={{ mt: 2 }} required fullWidth>

                                <FormLabel sx={{ fontWeight: '700', fontSize: 14, color: 'rgba(0, 0, 0, 0.8)', mb: 1}}>Apellido 1</FormLabel>
                                <TextField
                                    placeholder="Perez"
                                    autoComplete="off"                             
                                    variant="outlined"        
                                    value={ apellido1 }           
                                    onChange={ (e) => setApellido1( e.target.value ) }    
                                    disabled={ action === 'Buscar' && idUsuario === 0 }      
                                />

                            </FormControl>

                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>

                            <FormControl sx={{ mt: 2 }} fullWidth>

                                <FormLabel sx={{ fontWeight: '700', fontSize: 14, color: 'rgba(0, 0, 0, 0.8)', mb: 1}}>Apellido 2</FormLabel>
                                <TextField
                                    placeholder="Perez"
                                    autoComplete="off"                             
                                    variant="outlined"     
                                    value={ apellido2 }           
                                    onChange={ (e) => setApellido2( e.target.value ) }      
                                    disabled={ action === 'Buscar' && idUsuario === 0 }    
                                />

                            </FormControl>

                        </Grid>

                        <Grid size={{ xs: 12, md: 12 }}>

                            <FormControl sx={{ mt: 2 }} required fullWidth>

                                <FormLabel sx={{ fontWeight: '700', fontSize: 14, color: 'rgba(0, 0, 0, 0.8)', mb: 1}}>Correo electrónico</FormLabel>
                                <TextField
                                    type="email"
                                    placeholder="persona@pjecz.gob.mx"
                                    autoComplete="off"                             
                                    variant="outlined"       
                                    value={ correoElectronico }           
                                    onChange={ (e) => setCorreoElectronico( e.target.value ) }      
                                />

                            </FormControl>

                        </Grid>
                        
                        {
                            idUsuario !== 0
                            &&
                                <Grid size={{ xs: 12, md: 12 }}>

                                    <FormControl sx={{ mt: 2 }} required fullWidth>

                                        <FormLabel sx={{ fontWeight: '700', fontSize: 14, color: 'rgba(0, 0, 0, 0.8)', mb: 1 }}>Contraseña</FormLabel>
                                        <OutlinedInput
                                            placeholder="****************"                                
                                            autoComplete="current-password"  
                                            type={ showPassword ? 'text' : 'password' }
                                            value={ contrasena }           
                                            onChange={ (e) => setContrasena( e.target.value ) }
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        edge="end"
                                                        size='small'
                                                        aria-label={ showPassword ? 'hide the password' : 'display the password' }                                        
                                                        onClick={ () => setShowPassword( ( show ) => !show ) }
                                                    >
                                                        { showPassword ? <VisibilityOffIcon /> : <VisibilityIcon /> }
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                        />

                                    </FormControl>

                                </Grid>
                        } 
                      
                        <Grid size={{ xs: 12, md: 12 }}>

                            <FormControl sx={{ mt: 3 }} required fullWidth>
                                
                                <InputLabel>Tipo de usuario</InputLabel>                            
                                <Select                                                             
                                    label="Tipo de usuario"
                                    value={ tipousuario }
                                    onChange={ ( e ) => { setUnidad(0); setTipousuario( parseInt( e.target.value.toString() ) ); } }
                                >
                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>                        
                                    {
                                        tipousuarioArray.map( ( e ) => (
                                            <MenuItem key={ e.idTipoUsuario } value={ e.idTipoUsuario }>{ e.descripcion }</MenuItem>                                                        
                                        ))
                                    }     
                                </Select>

                            </FormControl>

                        </Grid>

                        {
                            tipousuario !== 1
                            &&
                                <Grid size={{ xs: 12, md: 12 }}>

                                    <FormControl sx={{ mt: 3 }} required fullWidth>
                                        
                                        <InputLabel>Unidad</InputLabel>                                    
                                        <Select                                                                               
                                            label="Unidad"
                                            value={ unidad }
                                            onChange={ ( e ) => { setUnidad( parseInt( e.target.value.toString() ) ); } }
                                        >
                                            <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>                        
                                            {
                                                unidadArray.map( ( e ) => (
                                                    <MenuItem key={ e.idUnidad } value={ e.idUnidad }>{ e.descripcion }</MenuItem>                                                        
                                                ))
                                            }      
                                        </Select>

                                    </FormControl>

                                </Grid>        
                        }                     
                        
                    </Grid>     

                </DialogContent>

                <DialogActions>

                    <Button 
                        color="secondary"
                        disabled={ loading } 
                        onClick={ () => { setOpenModal( false ); handleClose(); } }
                    > 
                        Cancelar 
                    </Button>

                    <Button 
                        loading={ loading } 
                        disabled={ 
                            tipousuario === 1
                            ?
                                idUsuario !== 0
                                ?
                                    curp === '' || nombre === '' || apellido1 === '' || correoElectronico === '' || contrasena === '' 
                                : 
                                    curp === '' || nombre === '' || apellido1 === '' || correoElectronico === ''
                            :
                                idUsuario !== 0
                                ?
                                    curp === '' || nombre === '' || apellido1 === '' || correoElectronico === '' || contrasena === '' || unidad === 0
                                : 
                                    curp === '' || nombre === '' || apellido1 === '' || correoElectronico === '' || unidad === 0
                        } 
                        variant='contained' 
                        onClick={ handleGuardar }
                    > 
                        Guardar 
                    </Button>

                </DialogActions>

            </Dialog>

        </Layout>
        
    )
}
